module.exports = __webpack_public_path__ + "img/256x256_square_warp_gate.c6fbbd05.svg";